module.exports = __webpack_public_path__ + "static/maali-founder-57bb0bef16a68686bc6fa67d6ea0f590.png";